// noinspection ES6UnusedImports
import React from 'react';
import createInformationLayerTextWithLink from './create-information-layer-text-with-link.jsx';
import {Typography} from "@bonprix/design-system";

export default function DeclarationOfConformity({texts, linkTarget}) {
    return (
        <Typography variant="body1" component="div">
            {createInformationLayerTextWithLink(texts.declaration_of_conformity, linkTarget)}
        </Typography>
    );
}
